const SectionPanel = ({ title, subtitle, action, children, className = "" }) => (
  <div
    className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-6 ${className}`}
  >
    <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between gap-3">
      <div>
        <h3 className="text-sm font-medium text-gray-900">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export default SectionPanel;
